import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import classes from "./SDGInitiativeDetail.module.css";
import { BaseURL } from "../home/BaseData";

const TEXT = {
  loading: { uz: "Yuklanmoqda...", en: "Loading...", ru: "Загрузка..." },
  notFoundTitle: {
    uz: "Ma'lumot topilmadi",
    en: "Not found",
    ru: "Материал не найден",
  },
  notFoundText: {
    uz: "Siz qidirayotgan tashabbus mavjud emas yoki o'chirilgan.",
    en: "The initiative you are looking for does not exist or has been removed.",
    ru: "Запрашиваемая инициатива не существует или была удалена.",
  },
  soon: {
    uz: "Ma'lumot tez kunda joylanadi.",
    en: "Content will be published soon.",
    ru: "Материал будет опубликован в ближайшее время.",
  },
  external: {
    uz: "Qo'shimcha havola",
    en: "Related link",
    ru: "Дополнительная ссылка",
  },
};

const SDGInitiativeDetail = () => {
  const { identifier } = useParams();
  const { i18n } = useTranslation();
  const [initiative, setInitiative] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchDetail = async () => {
      setLoading(true);
      setError(false);
      try {
        const urlsToTry = [
          `${BaseURL.replace(/\/$/, "")}/api/sdg/initiatives/${identifier}/`,
          `http://127.0.0.1:8001/api/sdg/initiatives/${identifier}/`,
          `http://127.0.0.1:8000/api/sdg/initiatives/${identifier}/`,
          `http://localhost:8000/api/sdg/initiatives/${identifier}/`,
          `http://localhost:8001/api/sdg/initiatives/${identifier}/`,
        ];
        let response = null;
        for (const url of urlsToTry) {
          try {
            response = await axios.get(url);
            if (response && response.data && response.data.initiative) break;
          } catch (e) {
            // try next
          }
        }

        if (response && response.data && response.data.initiative) {
          setInitiative(response.data.initiative);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching initiative detail:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (identifier) {
      fetchDetail();
    }
  }, [identifier]);

  const lang = i18n.language || "uz";
  const T = (key) => TEXT[key][lang] || TEXT[key].uz;

  const L = (obj, prefix) => {
    if (!obj) return "";
    return obj[`${prefix}_${lang}`] || obj[`${prefix}_uz`] || "";
  };

  if (loading) {
    return <div className={classes.loading}>{T("loading")}</div>;
  }

  if (error || !initiative) {
    return (
      <div className={classes.container}>
        <div className={classes.errorBox}>
          <h2 className={classes.errorTitle}>{T("notFoundTitle")}</h2>
          <p>{T("notFoundText")}</p>
        </div>
      </div>
    );
  }

  const image = initiative.image
    ? initiative.image.startsWith("http")
      ? initiative.image
      : `${BaseURL.replace(/\/$/, "")}${initiative.image.startsWith("/") ? "" : "/"}${initiative.image}`
    : null;

  const heading = L(initiative, "header_title") || L(initiative, "title");
  const category = L(initiative, "category");
  const description = L(initiative, "description");
  const content = L(initiative, "content");

  return (
    <div className={classes.page}>
      <div className={classes.hero}>
        {image && <img src={image} alt="" className={classes.heroImg} />}
        <div className={classes.heroScrim} />
        <div className={classes.heroInner}>
          {category && <span className={classes.eyebrow}>{category}</span>}
          <h1 className={classes.heroTitle}>{heading}</h1>
        </div>
      </div>

      <div className={classes.container}>
        {description && <p className={classes.lead}>{description}</p>}

        <div
          className={classes.richContent}
          dangerouslySetInnerHTML={{
            __html: content || `<p>${T("soon")}</p>`,
          }}
        />

        {initiative.link_url && (
          <a
            className={classes.externalLink}
            href={initiative.link_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {L(initiative, "link_text") || T("external")}
            <span aria-hidden="true"> ↗</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default SDGInitiativeDetail;
